import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { Trans } from "react-i18next";
import { ChevronDownIcon } from "@heroicons/react/solid";
import { motion } from "framer-motion";

const motionProps = {
  initial: { y: 0 },
  animate: { y: [0, -15, 0] },
  transition: {
    duration: 3,
    ease: "easeInOut",
    repeat: Infinity,
  },
};
const ScanNow = () => {
  return (
    <Flex
      position={"absolute"}
      alignItems={"center"}
      bottom={"0px"}
      right={"20px"}
    >
      <motion.div
        {...motionProps}
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Text fontSize={"xl"} fontWeight={"900"} mb={-4}>
          <Trans i18nKey={"scan_here"}>SCAN HERE</Trans>
        </Text>
        <ChevronDownIcon width={"80px"} />
      </motion.div>
    </Flex>
  );
};

export default ScanNow;
